import styled from 'styled-components'

export default styled('div')`
  margin-top: 20px;
  & > .recharts-wrapper {
    //margin: auto;
  }
`
